import React, { createContext, useState, useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import appConfig from '../config/appConfig';

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Use the JavaScript config that processes environment variables
        // and loads disclaimer text from JSON file
        const loadConfig = () => {
            try {
                console.log('[ConfigContext] Loading configuration from appConfig...');
                console.log('[ConfigContext] Loaded config:', appConfig);
                console.log('[ConfigContext] Default ticker:', appConfig.defaultTicker);
                console.log('[ConfigContext] Ticker list name:', appConfig.tickerListName);
                setConfig(appConfig);
            } catch (error) {
                console.error('Error loading application configuration:', error);
                // Fallback to a default configuration on error
                setConfig({ market: 'US', siteName: 'integralDelta.ai', companyName: 'Integral Delta LLC' });
            } finally {
                setLoading(false);
            }
        };

        loadConfig();
    }, []);

    const value = useMemo(() => ({ config, loading }), [config, loading]);

    return (
        <ConfigContext.Provider value={value}>
            {children}
        </ConfigContext.Provider>
    );
};

ConfigProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useConfig = () => {
    return useContext(ConfigContext);
};
